/* eslint no-param-reassign: 0 */
import React from 'react';
import { addHook, removeHook, sanitize } from 'dompurify';

export default function useSanitizeEmailBody(body) {
  const [sanitizedBody, setSanitizedBody] = React.useState('');

  React.useEffect(() => {
    // DOMPurify hooks are added "globally", so we'll add them here, sanitize,
    // then remove them after sanitization.
    addHook('afterSanitizeAttributes', (node) => {
      if (node.nodeName === 'A') {
        // Set all links to target="_blank" and rel="noopener noreferrer".
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener noreferrer');
        node.classList.add('text-primary-main');
      }

      if (node.nodeName === 'UL') {
        node.classList.add('list-disc', 'ml-4');
      }

      if (node.nodeName === 'OL') {
        node.classList.add('list-decimal', 'ml-6');
      }

      if (node.nodeName === 'BLOCKQUOTE') {
        node.classList.add(
          'pl-4',
          'box-border',
          'border-l-2',
          'border-grey-300',
        );
      }

      if (node.hasAttribute('style')) {
        const { backgroundColor, color } = node.style;
        node.removeAttribute('style');

        if (backgroundColor) {
          node.style.backgroundColor = backgroundColor;
        }

        if (color) {
          node.style.color = color;
        }
      }
    });

    setSanitizedBody(
      sanitize(body, {
        ALLOWED_TAGS: [
          'a',
          'b',
          'blockquote',
          'br',
          'div',
          'em',
          'font',
          'hr',
          'i',
          'img',
          'li',
          'ol',
          'p',
          'span',
          'strike',
          'strong',
          'table',
          'tbody',
          'td',
          'thead',
          'tr',
          'u',
          'ul',
        ],
        ALLOWED_ATTR: [
          'alt',
          // gmail uses "color" and "size" attributes on <font> for styling
          // color and size.
          'color',
          'colspan',
          'href',
          'id',
          'size',
          'src',
          'style',
        ],
      })
        .replace(/(\n)+/g, '')
        .trim(),
    );

    removeHook('afterSanitizeAttributes');
  }, [body]);

  return sanitizedBody;
}
